import { render } from "./TerritoryForm.vue?vue&type=template&id=1669383f&scoped=true"
import script from "./TerritoryForm.vue?vue&type=script&lang=js"
export * from "./TerritoryForm.vue?vue&type=script&lang=js"

import "./TerritoryForm.vue?vue&type=style&index=0&id=1669383f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1669383f"]])

export default __exports__